import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SystemStatusPollerService} from "./system-status-poller.service";
import {SystemStatus} from "./system-status";


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    SystemStatusPollerService,
    {provide: SystemStatus, useValue: new SystemStatus()}
  ]
})
export class SystemStatusModule {
}
